<div class="auth-modal" [class.guest-type-modal]="step === 'guest-type'">
  @if (step !== 'guest-type') {
    @if (!isLoggedIn && step === 'auth') {
      <img
        class="back-button"
        src="assets/img/white-back-arrow.svg"
        (click)="goBackToGuestType()" />
    } @else if (step === 'reset-password' || step === 'forgot-username') {
      <img
        class="back-button"
        src="assets/img/white-back-arrow.svg"
        (click)="goBackToSignIn()" />
    } @else if (step === 'phone-login') {
      <img
        class="back-button"
        src="assets/img/white-back-arrow.svg"
        (click)="onPhoneLoginBack()" />
    } @else if (!(step === 'auth' && alertMessage)) {
      <img
        class="close-button"
        src="assets/img/white-close.svg"
        (click)="dismiss()" />
    }
  }

  @if (step === 'guest-type') {
    @if (isTokenLoginLoading) {
      <div class="token-login-loading">
        <ion-spinner name="lines" />
        <tidy-text [body]="'Logging you in...'" />
      </div>
    } @else {
      <div class="guest-type-content">
        <div class="auth-header">
          <img src="assets/img/tidy-logo.svg" alt="TIDY" class="logo" />
          <tidy-text [title]="'Easily keep properties clean & maintained'" />
        </div>
        <div class="social-proof">
          <span class="material-icons star-icon">verified</span>
          <span>{{ 'Trusted by 100,000+ customers & top property managers' | translate }}</span>
        </div>
        <div class="guest-types">
          @for (type of guestTypes; track type.value) {
            <button
              class="guest-type-card"
              [disabled]="loadingGuestType !== null"
              (click)="selectAndConfirmGuestType(type.value)">
              <div class="type-icon-wrapper">
                <span class="material-icons type-icon">{{ type.icon }}</span>
              </div>
              <div class="type-content">
                <tidy-text [header]="type.label" />
              </div>
              @if (loadingGuestType === type.value) {
                <ion-spinner name="lines" class="card-spinner" />
              } @else {
                <span class="material-icons arrow-icon">arrow_forward</span>
              }
            </button>
          }
        </div>
        <div class="combined-footer">
          <span class="terms-section">
            <a href="https://www.tidy.com/terms" target="_blank">Terms</a>
            <span class="separator">•</span>
            <a href="https://www.tidy.com/legal/privacy-policy" target="_blank">Privacy</a>
          </span>
          <span class="separator">|</span>
          <span class="sign-in-section">
            <span class="muted-text">Have an account?</span>
            <a class="link" (click)="goToSignIn()">Sign In</a>
          </span>
        </div>
      </div>
    }
  }

  @if (step === 'auth') {
    <div class="auth-content" [class.has-alert-header]="alertMessage">
      @if (alertMessage) {
        <div class="modal-header">
          <div class="modal-header-title">
            <tidy-text class="title-text" [header]="alertMessage" />
          </div>
          <img
            class="close-icon"
            src="assets/img/white-close.svg"
            (click)="dismiss()" />
        </div>
      } @else {
        <div class="auth-header">
          <img src="assets/img/tidy-logo.svg" alt="TIDY" class="logo" />
        </div>
      }

      @if (isTokenLoginLoading) {
        <div class="token-login-loading">
          <ion-spinner name="lines" />
          <tidy-text [body]="'Logging you in...'" />
        </div>
      } @else {
        @if (!alertMessage && !signInOnly) {
          <div class="auth-tabs">
            <button
              class="tab"
              [class.active]="mode === 'signin'"
              (click)="switchMode('signin')">
              Sign In
            </button>
            <button
              class="tab"
              [class.active]="mode === 'signup'"
              (click)="switchMode('signup')">
              Sign Up
            </button>
          </div>
        }

        <div class="social-buttons">
          <button class="social-button google" (click)="signInWithGoogle()">
            <svg viewBox="0 0 24 24" width="20" height="20">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            <span>Google</span>
          </button>
          <button class="social-button apple" (click)="signInWithApple()">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
              <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
            </svg>
            <span>Apple</span>
          </button>
        </div>

        <div class="divider">
          <span>or</span>
        </div>

        @if (mode === 'signin') {
          <form [formGroup]="signInForm" class="auth-form">
            <tidy-input
              formControlName="email"
              [form]="signInForm.controls.email"
              [label]="'Email'"
              type="email"
              [errorMessage]="'Please enter a valid email.'"
              [submitted]="submitted"
              [icon]="'assets/svg/mail.svg'" />
            <tidy-input
              formControlName="password"
              [form]="signInForm.controls.password"
              [label]="'Password'"
              type="password"
              [errorMessage]="'Password is required.'"
              [submitted]="submitted"
              [icon]="'assets/svg/lock-closed.svg'" />
            @if (errorMessage) {
              <tidy-error-message [text]="errorMessage" />
            }
            <tidy-row>
              <tidy-button
                [text]="'Sign In'"
                [action]="onSignIn.bind(this)"
                class="primary full-width" />
            </tidy-row>
            <div class="forgot-links">
              <tidy-text [actionBody]="'Forgot password?'" (action)="forgotPassword()" />
              <tidy-text [actionBody]="'Forgot username?'" (action)="forgotUsername()" />
              <tidy-text [actionBody]="'Sign in with phone number'" (action)="loginWithPhone()" />
            </div>
          </form>
        }

        @if (mode === 'signup') {
          <form [formGroup]="signUpForm" class="auth-form">
            <div class="form-row">
              <tidy-input
                formControlName="firstName"
                [form]="signUpForm.controls.firstName"
                [label]="'First Name'"
                [errorMessage]="'Please enter your first name.'"
                [submitted]="submitted"
                [icon]="'assets/svg/person.svg'" />
              <tidy-input
                formControlName="lastName"
                [form]="signUpForm.controls.lastName"
                [label]="'Last Name'"
                [errorMessage]="'Please enter your last name.'"
                [submitted]="submitted"
                [icon]="'assets/svg/person.svg'" />
            </div>
            <tidy-input
              formControlName="email"
              [form]="signUpForm.controls.email"
              [label]="'Email'"
              type="email"
              [errorMessage]="'Please enter a valid email.'"
              [submitted]="submitted"
              [icon]="'assets/svg/mail.svg'" />
            <tidy-input
              formControlName="password"
              [form]="signUpForm.controls.password"
              [label]="'Password'"
              type="password"
              [errorMessage]="'Password must be at least 8 characters.'"
              [submitted]="submitted"
              [icon]="'assets/svg/lock-closed.svg'" />
            @if (errorMessage) {
              <tidy-error-message [text]="errorMessage" />
            }
            <tidy-row>
              <tidy-button
                [text]="'Create Account'"
                [action]="onSignUp.bind(this)"
                class="primary full-width" />
            </tidy-row>
            <tidy-row [align]="'center'">
              <tidy-text [helper]="'By creating an account, you agree to our'" /><span>&nbsp;</span>
              <tidy-text [body]="'Terms of Service'" (action)="openUrl('https://www.tidy.com/terms')" class="link"/><span>&nbsp;</span>
              <tidy-text [helper]="'and'" /><span>&nbsp;</span>
              <tidy-text [body]="'Privacy Policy'" (action)="openUrl('https://www.tidy.com/legal/privacy-policy')" class="link"/>
            </tidy-row>
          </form>
        }
      }
    </div>
  }

  @if (step === 'account-type') {
    <div class="account-type-content">
      <img
        class="back-button"
        src="assets/img/white-back-arrow.svg"
        (click)="goBackToAuth()" />

      <div class="auth-header">
        <h1>How will you use TIDY?</h1>
        <p>This helps us personalize your experience</p>
      </div>

      <div class="account-types">
        @for (type of accountTypes; track type.value) {
          <button
            class="account-type-card"
            [class.selected]="selectedAccountType === type.value"
            (click)="selectAccountType(type.value)">
            <span class="material-icons type-icon">{{ type.icon }}</span>
            <div class="type-content">
              <span class="type-label">{{ type.label }}</span>
              <span class="type-description">{{ type.description }}</span>
            </div>
            @if (selectedAccountType === type.value) {
              <span class="material-icons check-icon">check_circle</span>
            }
          </button>
        }
      </div>

      @if (errorMessage) {
        <div class="error-message">{{ errorMessage }}</div>
      }

      <tidy-row>
        <tidy-button
          [text]="'Create Account'"
          [action]="completeSignUp.bind(this)"
          [disabled]="!selectedAccountType"
          class="primary full-width" />
      </tidy-row>
    </div>
  }

  @if (step === 'convert') {
    <div class="auth-content">
      <div class="auth-header">
        <img src="assets/img/tidy-logo.svg" alt="TIDY" class="logo" />
        <h1>Save Your Account</h1>
        <p>Enter your details to keep your data</p>
      </div>

      <div class="social-buttons">
        <button class="social-button google" (click)="signInWithGoogle()">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          <span>Google</span>
        </button>
        <button class="social-button apple" (click)="signInWithApple()">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
          </svg>
          <span>Apple</span>
        </button>
      </div>

      <div class="divider">
        <span>or</span>
      </div>

      <form [formGroup]="convertForm" class="auth-form">
        <div class="form-row">
          <tidy-input
            formControlName="firstName"
            [form]="convertForm.controls.firstName"
            [label]="'First Name'"
            [errorMessage]="'Please enter your first name.'"
            [submitted]="submitted"
            [icon]="'assets/svg/person.svg'" />
          <tidy-input
            formControlName="lastName"
            [form]="convertForm.controls.lastName"
            [label]="'Last Name'"
            [errorMessage]="'Please enter your last name.'"
            [submitted]="submitted"
            [icon]="'assets/svg/person.svg'" />
        </div>
        <tidy-input
          formControlName="email"
          [form]="convertForm.controls.email"
          [label]="'Email'"
          type="email"
          [errorMessage]="'Please enter a valid email.'"
          [submitted]="submitted"
          [icon]="'assets/svg/mail.svg'" />
        <tidy-input
          formControlName="password"
          [form]="convertForm.controls.password"
          [label]="'Password'"
          type="password"
          [errorMessage]="'Password must be at least 8 characters.'"
          [submitted]="submitted"
          [icon]="'assets/svg/lock-closed.svg'" />
        @if (errorMessage) {
          <tidy-error-message [text]="errorMessage" />
        }
        <tidy-row>
          <tidy-button
            [text]="'Save Account'"
            [action]="onConvertAccount.bind(this)"
            class="primary full-width" />
        </tidy-row>
        <p class="terms-text">
          Already have an account?
          <a (click)="switchToSignIn()" style="cursor: pointer;">Sign in instead</a>
        </p>
      </form>
    </div>
  }

  @if (step === 'reset-password') {
    <div class="auth-content">
      <div class="auth-header">
        <img src="assets/img/tidy-logo.svg" alt="TIDY" class="logo" />
        <h1>Reset Password</h1>
        <p>Enter your email address and we'll send you instructions to reset your password</p>
      </div>

      <form [formGroup]="resetPasswordForm" class="auth-form">
        <tidy-input
          formControlName="email"
          [form]="resetPasswordForm.controls.email"
          [label]="'Email'"
          type="email"
          [errorMessage]="'Please enter a valid email.'"
          [submitted]="submitted"
          [icon]="'assets/svg/mail.svg'" />
        @if (errorMessage) {
          <tidy-error-message [text]="errorMessage" />
        }
        @if (successMessage) {
          <div class="success-message">{{ successMessage }}</div>
        }
        <tidy-row>
          <tidy-button
            [text]="'Send Reset Instructions'"
            [action]="onResetPassword.bind(this)"
            [disabled]="isLoading"
            class="primary full-width" />
        </tidy-row>
      </form>
    </div>
  }

  @if (step === 'forgot-username') {
    <div class="auth-content">
      <div class="auth-header">
        <img src="assets/img/tidy-logo.svg" alt="TIDY" class="logo" />
        <h1>Forgot Username</h1>
        <p>Enter your account information to recover your username</p>
      </div>

      <form [formGroup]="forgotUsernameForm" class="auth-form">
        <tidy-input
          formControlName="phone"
          [form]="forgotUsernameForm.controls.phone"
          [label]="'Phone Number'"
          type="tel"
          [errorMessage]="'Please enter your phone number.'"
          [submitted]="submitted"
          [icon]="'assets/svg/phone-portrait.svg'" />
        <tidy-input
          formControlName="address1"
          [form]="forgotUsernameForm.controls.address1"
          [label]="'Street Address'"
          [errorMessage]="'Please enter your street address.'"
          [submitted]="submitted"
          [icon]="'assets/svg/home.svg'" />
        <tidy-input
          formControlName="zipcode"
          [form]="forgotUsernameForm.controls.zipcode"
          [label]="'Zip Code'"
          [errorMessage]="'Please enter your zip code.'"
          [submitted]="submitted"
          [icon]="'assets/svg/location.svg'" />
        @if (errorMessage) {
          <tidy-error-message [text]="errorMessage" />
        }
        @if (successMessage) {
          <div class="success-message">{{ successMessage }}</div>
        }
        <tidy-row>
          <tidy-button
            [text]="'Recover Username'"
            [action]="onForgotUsername.bind(this)"
            [disabled]="isLoading"
            class="primary full-width" />
        </tidy-row>
      </form>
    </div>
  }

  @if (step === 'phone-login') {
    <div class="auth-content">
      <div class="auth-header">
        <img src="assets/img/tidy-logo.svg" alt="TIDY" class="logo" />
        <h1>Sign in with phone</h1>
        @if (codeSent) {
          <p>Enter the code to sign in</p>
        } @else {
          <p>We'll text you a one-time code to sign in</p>
        }
      </div>

      <form [formGroup]="phoneLoginForm" class="auth-form">
        @if (!codeSent) {
          <tidy-input-international-phone
            formControlName="phone"
            [form]="phoneLoginForm.controls.phone"
            [label]="'Phone Number'"
            [inputMode]="'numeric'"
            [errorMessage]="'Please enter a valid phone number.'"
            [submitted]="submitted"
            [icon]="'assets/svg/phone-portrait.svg'"
            [initialMask]="{ mask: '[00000000000000000000000]' }" />
          @if (errorMessage) {
            <tidy-error-message [text]="errorMessage" />
          }
          <tidy-row>
            <tidy-button
              [text]="'Send Code'"
              [action]="onSendPhoneCode.bind(this)"
              [disabled]="isLoading"
              class="primary full-width" />
          </tidy-row>
        } @else {
          @if (successMessage) {
            <div class="success-message">{{ successMessage }}</div>
          }
          <tidy-input
            formControlName="code"
            [form]="phoneLoginForm.controls.code"
            [label]="'Code'"
            type="tel"
            [errorMessage]="'Please enter the code.'"
            [submitted]="submitted"
            [icon]="'assets/svg/lock-closed.svg'" />
          @if (errorMessage) {
            <tidy-error-message [text]="errorMessage" />
          }
          <tidy-row>
            <tidy-button
              [text]="'Sign In'"
              [action]="onVerifyPhoneCode.bind(this)"
              [disabled]="isLoading"
              class="primary full-width" />
          </tidy-row>
          <div class="forgot-links">
            <tidy-text [actionBody]="'Use a different number'" (action)="useDifferentPhoneNumber()" />
          </div>
        }
      </form>
    </div>
  }
</div>
